const validate = {
  rules: {
    regiao_id: {
      required: true,
    },
    vendedor_id: {
      required: true,
    },
    // descricao: {
    //   required: true,
    // },
  },
  messages: {
    //estado_id: "O estado é obrigatório.",
    vendedor_id: "O vendedor é obrigatório.",
    regiao_id: "A região é obrigatória.",
  },
};

export default validate;
